import {ValueObject} from '@s-ui/domain'

export class TradeCostsListTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array<Object>} data.costs
   * @param {Number} data.purchasePrice
   * @param {Number} data.totalAmount
   */

  static create = ({costs, purchasePrice, totalAmount}) => {
    return new TradeCostsListTransactionsValueObject({costs, purchasePrice, totalAmount})
  }

  static fromApiResponse = ({costs, purchasePrice, totalAmount}) => {
    const parsedPurchasePrice = typeof purchasePrice === 'string' ? Number(purchasePrice) : purchasePrice
    const parsedTotalAmount = typeof totalAmount === 'string' ? Number(totalAmount) : totalAmount

    const parsedCosts = costs.map(({description, amount}) => {
      const parsedAmount = typeof amount === 'string' ? Number(amount) : amount

      return {description, amount: parsedAmount}
    })

    return new TradeCostsListTransactionsValueObject({
      costs: parsedCosts,
      purchasePrice: parsedPurchasePrice,
      totalAmount: parsedTotalAmount
    })
  }
}
